/** Re-layout Google Maps after the container size changes (e.g. sidebar or column resize). */
export const triggerGoogleMapResize = (map?: google.maps.Map | null) => {
  if (!map || !window.google?.maps?.event) {
    return;
  }
  window.google.maps.event.trigger(map, 'resize');
};

export const scheduleGoogleMapResize = (
  map?: google.maps.Map | null,
  delaysMs: number[] = [0, 100, 350, 600]
) => {
  const timers = delaysMs.map((delay) =>
    window.setTimeout(() => triggerGoogleMapResize(map), delay)
  );
  return () => timers.forEach((timer) => window.clearTimeout(timer));
};
